import React, { Component } from 'react';
import { connect } from "react-redux";
import {setEffectsPaneOption} from 'actions/index.js';
import {HIDE} from 'components/mix/constants.js';
import {TRACK} from 'components/mix/constants.js';
import {EFFECTS} from 'components/mix/constants.js';

/**
 * side bar that lets you hide the pane, navigate to track parameters,
 * and also effect parameterse
 */
class EffectsPaneSidebar extends Component {
    constructor(props) {
        super(props);
    }

    onClickOption(option) {
        this.props.setEffectsPaneOption(option);
    }

    render() {
        if (this.props.option == HIDE) {
            return (
                <div className="effects-pane-sidebar">
                  <div
                    onClick={() => this.onClickOption(EFFECTS)}
                    className="sidebar-option">
                    SHOW
                  </div>
                </div>
                   );
        }

        return (
            <div className="effects-pane-sidebar">
              <div
                onClick={() => this.onClickOption(HIDE)}
                className="sidebar-option">
                HIDE
              </div>
              <div
                onClick={() => this.onClickOption(TRACK)}
                className={this.props.option == TRACK ?
                  "selected sidebar-option" : "sidebar-option"}>
                TRACK
              </div>
              <div
                onClick={() => this.onClickOption(EFFECTS)}
                className={this.props.option == EFFECTS ?
                  "selected sidebar-option" : "sidebar-option"}>
                EFFECTS
              </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        option: state.mix.effectsPaneOption,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setEffectsPaneOption: option => dispatch(setEffectsPaneOption(option)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectsPaneSidebar);
